import * as React from "react"
import {Grid, Segment} from "semantic-ui-react"
import {BookingFormJourneyState} from "../state"
import {LocaleFragment} from "../graphql/queries"
import {DirectionsMap} from "./DirectionsMap"
import {Place} from "../model/places/PlaceTypes"
import {mixed} from "../tsutil"

interface OuterState {
  mapJourney: BookingFormJourneyState
  mapLocale: LocaleFragment
}

interface InnerState {
  state: OuterState | null
  optimizeWaypoints: boolean
}

export interface MapContentParams {
  setMapState(state: OuterState | null): void
  resetMapState(): void
  optimizeMapJourney(): Promise<Array<Place> | null>
}

interface Props {
  defaultState: OuterState
  render(params: MapContentParams): React.ReactNode
}

interface PendingPromise<T> {
  promise: Promise<T>
  reject(e?: mixed): void
  resolve(x: T): void
}

function newPendingPromise<T>(): PendingPromise<T> {
  let resolve
  let reject
  const promise = new Promise<T>((res, rej) => {
    resolve = res
    reject = rej
  })
  if (resolve && reject) {
    return {promise, resolve, reject}
  }
  throw new Error("This shouldn't be possible")
}

export class BookingWizardWrapper extends React.Component<Props, InnerState> {
  promises: Array<PendingPromise<Array<Place> | null>> = []

  constructor(props: Props) {
    super(props)
    this.state = {
      state: null,
      optimizeWaypoints: false,
    }
  }

  render() {
    const state = this.state.state || this.props.defaultState
    return (
      <Grid stackable columns={2}>
        <Grid.Column>
          <Segment.Group>
            <Segment inverted color="olive">
              {this.props.render({
                optimizeMapJourney: () => {
                  const promise = newPendingPromise<Array<Place> | null>()
                  this.promises.push(promise)
                  this.setState({optimizeWaypoints: true})
                  return promise.promise
                },
                setMapState: (state: OuterState | null) => {
                  this.setState({state})
                },
                resetMapState: () => {
                  this.setState({state: null})
                },
              })}
            </Segment>
          </Segment.Group>
        </Grid.Column>
        <Grid.Column>
          <DirectionsMap
            journey={state.mapJourney}
            locale={state.mapLocale}
            onOptimizedWaypoints={
              this.state.optimizeWaypoints
                ? (waypoints: Array<Place> | null) => {
                    // Resolve all the promises
                    while (true) {
                      const promise = this.promises.pop()
                      if (promise) {
                        promise.resolve(waypoints)
                      } else {
                        break
                      }
                    }
                    this.setState({optimizeWaypoints: false})
                  }
                : null
            }
          />
        </Grid.Column>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BookingWizardWrapper.tsx